var a = "/static/fa10c51cc4c429fd.png";

export { a as default };
//# sourceMappingURL=airdrop.png.js.map
